var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path === '/osmember/infoMO' || _vm.$route.path === '/osmember/archive')?_c('span',[_c('Main',{attrs:{"archive":_vm.archive,"selectedYear":_vm.selectedYear}})],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }